import Highcharts from "highcharts";
import { toSafeNumber } from "../data/transformers";
import { PIE_CHART_DRILLDOWN_OPTIONS } from "src/config/charts/pieDrilldownChartConfig";

type DrilldownProps = {
  series?: {
    name?: string;
    data?: Record<string, unknown>[];
  }[];
  drilldown?: {
    series?: {
      id?: string;
      name?: string;
      data?: Array<Record<string, unknown> | unknown[]>;
    }[];
  };
};

function buildPieDrilldownOptions(data: DrilldownProps) {
  const topLevelSeries = data?.series?.[0];
  const topLevelData = (topLevelSeries?.data ?? []).map((point) => {
    const pointName = String(point.name ?? "");
    const pointY = toSafeNumber(point.y ?? point.percentage);
    const drilldownId = point.drilldown ? String(point.drilldown) : undefined;

    return {
      name: pointName,
      y: pointY,
      value: point.value ?? point.percentage ?? pointY,
      tooltip: pointName.split("-")[0]?.trim() || pointName,
      ...(drilldownId ? { drilldown: drilldownId } : {}),
    };
  });

  const drilldownSeries = (data?.drilldown?.series ?? []).map((series) => {
    const seriesId = String(series.id ?? series.name ?? "");

    return {
      ...series,
      id: seriesId,
      name: series.name ?? seriesId,
      type: "pie",
      data: (series.data ?? []).map((point) => {
        if (Array.isArray(point)) {
          const pointName = String(point[0] ?? "");
          const pointY = toSafeNumber(point[1]);

          return {
            name: pointName,
            y: pointY,
            value: point[2] ?? pointY,
            tooltip: pointName,
          };
        }

        const pointName = String(point.name ?? "");
        const pointY = toSafeNumber(point.y);

        return {
          name: pointName,
          y: pointY,
          value: point.value ?? pointY,
          tooltip: point.tooltip ?? pointName,
        };
      }),
    };
  });

  return {
    ...PIE_CHART_DRILLDOWN_OPTIONS,
    series: topLevelSeries
      ? [
          {
            ...topLevelSeries,
            name: topLevelSeries.name ?? "",
            type: "pie",
            data: topLevelData,
          },
        ]
      : [],
    drilldown: {
      series: drilldownSeries,
    },
  };
}

export const renderPieDrilldown = (
  data: unknown,
  spec: unknown,
  title: string,
): Highcharts.Options => {
  const drilldownData = data as DrilldownProps;
  const options = buildPieDrilldownOptions(drilldownData);
  return {
    ...options,
    // title: {
    //   text: title,
    //   align: "left",
    // },
  };
};
